// v3.0.0-rc.7-phaseCD-CD_WALLET_RICH_PURCHASE_V1 — Phase D.2 · WalletQuickLink
//
// Mini-pill flottant affichant le solde courant + lien direct vers /wallet.
// Fetch GET /api/v3/wallet/balance au mount + re-fetch quand l'événement
// `civ:auth-changed` survient (login/logout). Palette vert émeraude + gold
// alignée avec WalletB2cPage.

import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "@/utils/apiClient";
import { useAuth } from "@/hooks/useAuth";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const C = {
  bg: "rgba(15, 46, 32, 0.92)",
  border: "rgba(212, 175, 55, 0.55)",
  gold: "#D4AF37",
  ivory: "#F5F1E6",
};

function _fmtCFA(n) {
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("fr-FR").format(Math.round(n)) + " FCFA";
}

export default function WalletQuickLink({ inline = false }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) { setBalance(null); return; }
    setLoading(true);
    try {
      const r = await apiFetch(`${BACKEND}/api/v3/wallet/balance`);
      if (r.ok) {
        const d = await r.json();
        if (d?.ok) setBalance(Number(d.balance_fcfa) || 0);
      }
    } catch (_) { /* swallow */ }
    finally { setLoading(false); }
  }, [isAuthenticated]);

  useEffect(() => { refresh(); }, [refresh]);

  if (!isAuthenticated) return null;

  return (
    <button
      type="button"
      data-testid="wallet-quicklink-btn"
      onClick={() => navigate("/wallet")}
      title="Ouvrir mon Wallet"
      style={{
        ...(inline
          ? { position: "static", width: "100%", justifyContent: "space-between" }
          : {
              position: "fixed",
              top: "max(env(safe-area-inset-top, 0px) + 12px, 12px)",
              right: 14,
              zIndex: 50,
            }),
        display: inline ? "flex" : "inline-flex", alignItems: "center", gap: 8,
        padding: inline ? "12px 16px" : "8px 14px",
        background: C.bg,
        border: `1px solid ${C.border}`,
        borderRadius: inline ? 14 : 999,
        color: C.ivory,
        fontSize: 13, fontWeight: 600,
        cursor: "pointer",
        boxShadow: "0 4px 14px rgba(0,0,0,0.32)",
        backdropFilter: "blur(8px)",
      }}
    >
      <span style={{ fontSize: 15, lineHeight: 1 }}>💼</span>
      <span data-testid="wallet-quicklink-balance" style={{ color: C.gold, fontFeatureSettings: "'tnum'" }}>
        {loading && balance === null ? "…" : _fmtCFA(balance ?? 0)}
      </span>
    </button>
  );
}
